




















































































import  {Component} from "vue-property-decorator";
import DatenschutzFaTab from "./Generic/DatenschutzFaTab.vue";
import {LookupModule, LookupStore} from "@/store/modules/lookup-store";

@Component({})
export default class DatenschutzFa5Abhilfemassnahmen extends DatenschutzFaTab {
    public lookupStore: LookupModule = LookupStore;

    public showAbhilfenassnahmen(riskValue: string):boolean{
        return riskValue != 'D3' && riskValue != 'D4' && riskValue != 'C4';
    }
}
